import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'audit'
const auditEnumUrl = 'audit/enums'
const plural = 'audits'
const single = 'audit'
// const exportAuditUrl = 'audit/export'

const api = new ApiCore({
	index: true,
	findOne: true,
	url: url,
	plural: plural,
	single: single
})

api.getAuditEnum = (action) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${auditEnumUrl}`)
		.then(handleResponse)
		.catch(handleError);
}

// api.exportAuditData = (payload, type, params) => {
// 	return axios
// 		.post(`${apiProvider.BASE_URL}/${exportAuditUrl}/${type}`, payload, params)
// 		.then(handleResponse)
// 		.catch(handleError);
// }

export default api
